//import { uploadBase64 } from 'helpers/fb-storage';

export const create = async data => {
 const newProject = {
  ...data,
  //images: await uploadBase64(data.images),
  //logo: (await uploadBase64(data.logo))[0],
  //blueprints: (await uploadBase64(data.blueprints))[0],
  // eslint-disable-next-line no-unused-vars
  products: data?.products.map(({ project, ...newProduct }) => newProduct)
 };

 return newProject;
};
